<script lang="ts">
    import type {AxiosInstance} from 'axios';
    import {fade} from 'svelte/transition';

    import {dyData, modal} from 'general/store';
    import {STATE, ANIMATION_DURATION, TEMPLATE} from 'general/constants';

    import FlipWrapper from 'general/components/flip/wrapper/FlipWrapper.svelte';
    import Backdrop from 'general/components/backdrop/Backdrop.svelte';
    import Position from 'desktop/components/position/Position.svelte';
    import MainSide from './state/Main.svelte';
    import ThankYouSide from './state/ThankYou.svelte';
    import ThankYouQRSide from './state/ThankYouQR.svelte';
    import SubscribedSide from './state/Subscribed.svelte';
    import SmsSide from './state/Sms.svelte';
    import SmsQrSide from './state/SmsQR.svelte';

    export let instance: AxiosInstance;

    const isQrCode = Boolean($dyData.qrCode);
    const isTypQrCode = Boolean($dyData.qrCode?.typ);

    const OPTIONS = {
        [STATE.MAIN]: {component: MainSide, props: {instance}},
        [STATE.TYP]: {
            component: isTypQrCode ? ThankYouQRSide : ThankYouSide,
            props: isTypQrCode ? {instance} : {},
        },
        [STATE.ALREADY_SUBSCRIBED]: {component: SubscribedSide, props: {}},
        [STATE.SMS]: {component: isQrCode ? SmsQrSide : SmsSide, props: {instance}},
    } as const;
</script>

<div transition:fade|global={{duration: ANIMATION_DURATION.MODAL}}>
    <Position>
        <FlipWrapper template={TEMPLATE.CIRCLE}>
            <svelte:component
                this={OPTIONS[$modal.state].component}
                {...OPTIONS[$modal.state].props}
            />
        </FlipWrapper>
    </Position>
    <Backdrop />
</div>
